import { AxiosResponse } from "axios";

import { microserviceApiRoutes } from "../../microservice-api.routes";
import { microserviceApiAxios } from "../../microservice-api.axios";
import {
  ITouchIDAgentsServiceBodyReq,
  ITouchIDAgentsServiceRes,
  ITouchIDInfoAgentsServiceBodyReq,
  ITouchIDInfoAgentsServiceRes,
} from "./touch-service.interface";

export const touchIDAgentsService = (data: ITouchIDAgentsServiceBodyReq) => {
  const url = microserviceApiRoutes.v1.agents.touch.create();
  return microserviceApiAxios
    .post<Error, AxiosResponse<ITouchIDAgentsServiceRes>>(url, data)
    .then((res) => res.data);
};

export const getTouchIDInfoAgentsService = (
  data: ITouchIDInfoAgentsServiceBodyReq,
) => {
  const url = microserviceApiRoutes.v1.agents.touch.verify();
  return microserviceApiAxios
    .post<Error, AxiosResponse<ITouchIDInfoAgentsServiceRes>>(url, data)
    .then((res) => res.data);
};
